import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config,reactSelectStyles, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import AdaniUserFilter from '../../filters/AdaniUserFilter.jsx';
import AdaniGasStationFilter from '../../filters/AdaniGasStationFilter.jsx';
import AdaniGasStationLocationFilter from '../../filters/AdaniGasStationLocationFilter.jsx';
import NotificationSystem from "react-notification-system";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');

class AdaniGasStationDailyReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            txnTypeLists:[{value:'Credit', label: 'Credit'},{value:'Debit', label: 'Debit'}],
            txnTypeValue:'',
            txnType:'',
            ledgerLists:[{value:'Credit', label: 'Credit'},{value:'Debit', label: 'Debit'}],
            ledgerValue:'',
            ledger:'',
            adani_email:'',
            gas_station_name:'',
            gas_station_location:'',
            _notificationSystem: null,
            is_success:true,
            gas_station_id:""

        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'adani_gas_station_daily_report');

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: stringCode,
            userType: decoded.userType,
            user_email: decoded.email,
            gas_station_id: decoded.warehouse_id
        });
    }
    componentDidUpdate() {

    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.get_filtered_adani_gas_station_txn_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'adani_gas_station_daily_report','sparcs')
    }

    get_filtered_adani_gas_station_txn_report(object_type, object_code, event) {
        var gas_station_id=this.state.gas_station_id;
        if(this.state.object_type ==='Adani' && this.state.object_code ==='Adani'){
            gas_station_id = [this.state.gas_station_id];
        }
        var that = this;
        isApiResponse(false);
        var postData = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            txnType: this.state.txnType,
            ledger: this.state.ledger,
            user_email: this.state.adani_email,
            user_type: this.state.userType,
            object_type: this.state.object_type,
            gas_station_name: this.state.gas_station_name,
            gas_station_location: this.state.gas_station_location,
            gas_station_id: gas_station_id
        };
        var customer_name = 'customer_id';
        var customer_contact = 'customer_id';
        var driver_contact_number = 'customer_id';
        var driver_license_number = 'customer_id';
        var wallet_id = 'customer_id';
        if(that.state.userType=='Internal' && this.state.object_type=='Innoviti') {
            customer_name = 'customer_name';
            customer_contact = 'customer_contact';
            driver_contact_number = 'driver_contact_number';
            driver_license_number = 'driver_license_number';
            wallet_id = 'wallet_id';
        }

        var columns_list = [
            {"data":"customer_id" },
            {"data": customer_name },
            {"data": customer_contact },
            {"data":"vehicle_id" },
            {"data":"vehicle_number" },
            {"data":"driver_id" },
            {"data":"driver_name" },
            {"data": driver_contact_number },
            {"data": driver_license_number },
            {"data": wallet_id},
            {"data":"assigned_wallet_balance" },
            {"data":"gas_station_id" },
            {"data":"gas_station_name" },
//             {"data":"customer_location" },
            {"data":"transaction_id" },
            {"data":"transaction_type" },
            {"data":"flag" },
            {"data":"transaction_amount" },
            {"data":"utid" },
            {"data":"serial_number" },
            {"data":"location_gas_station" },
            {"data":"transaction_date" },
            {"data":"transaction_time" }
            ]
        if ($.fn.DataTable.isDataTable('#AdaniGasDailyReportTable')) {
            $('#AdaniGasDailyReportTable').DataTable().clear().destroy();
        }
        var AdaniGasDailyReportTable = $('#AdaniGasDailyReportTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/adaniGasReports/daily-report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: columns_list,
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 20
                    },
                    {  render: function (data) {
                            if(data===null || data===''|| data ==='null'){
                                data = '';
                                return '<td >'+data+'</td>';
                            } else{
                                return '<td >'+moment(data, "HH:mm:ss").format("hh:mm A")+'</td>';
                            }

                        },
                        "width": "80px",
                        "targets": 21
                    },

                ],
            });
            if(that.state.userType=='Internal' && this.state.object_type=='Innoviti') {
                AdaniGasDailyReportTable.columns(1).visible(true);
                AdaniGasDailyReportTable.columns(2).visible(true);
                AdaniGasDailyReportTable.columns(7).visible(true);
                AdaniGasDailyReportTable.columns(8).visible(true);
                AdaniGasDailyReportTable.columns(9).visible(true);
            } else {
                AdaniGasDailyReportTable.columns(1).visible(false);
                AdaniGasDailyReportTable.columns(2).visible(false);
                AdaniGasDailyReportTable.columns(7).visible(false);
                AdaniGasDailyReportTable.columns(8).visible(false);
                AdaniGasDailyReportTable.columns(9).visible(false);


            }
    }


    adani_gas_station_txn_report_download(){
        var gas_station_id=this.state.gas_station_id;
        if(this.state.object_type ==='Adani' && this.state.object_code ==='Adani'){
            gas_station_id = [this.state.gas_station_id];
        }
    var filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            transaction_type: this.state.txnType,
            ledger: this.state.ledger,
            user_email: this.state.adani_email,
            user_type: this.state.userType,
            object_type: this.state.object_type,
            gas_station_name: this.state.gas_station_name,
            gas_station_location: this.state.gas_station_location,
            download: 1,
            gas_station_id: gas_station_id
        };

    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){

        confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, '/summary_reports/utid/wise/summary','utid_wise_summary_report');
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/adani_reports/adani_gas_station/transaction_report','adani_gas_station_txn_report');
        }
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.adaniUserFilter.resetEmailFilter();
            this.refs.adaniGasStationFilter.resetGasStationFilter();
            this.refs.adaniGasStationLocationFilter.resetGasStationLocationFilter();

        }

        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            txnTypeValue:[],
            txnType:'',
            ledger:'',
            ledgerValue:[],
            adani_email:'',
            gas_station_name:'',
            gas_station_location:'',
            isChange: false,
        })
        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    change_txn(optionSelected)
    {
        let value='';
        let txnArray = [];
        if(optionSelected.length < 1){
            value = null;
            txnArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)

            });
        }

        this.setState({
            txnType:txnArray,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }
    change_ledger(optionSelected)
    {
        let value='';
        let txnArray = [];
        if(optionSelected.length < 1){
            value = null;
            txnArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)

            });
        }

        this.setState({
            ledger:txnArray,
            ledgerValue:optionSelected,
            isChange: true
        });
    }
    handleEmail = (optionSelected, adani_email) =>
    {
        this.setState({
            adani_email:adani_email,
            isChange: true
        });
    }
    handleGasStation = (optionSelected, selected_gas_station_name) =>
    {
        this.setState({
            gas_station_name:selected_gas_station_name,
            isChange: true
        });
    }
    handleGasStationLocation = (optionSelected, selected_gas_station_loc) =>
    {
        this.setState({
            gas_station_location:selected_gas_station_loc,
            isChange: true
        });
    }
    refresh_txn (){
        this.setState({
            is_success:false
        })
        axios.post(config.get('API_URL') + '/adaniGasReports/refresh-txn/', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                console.log(response.data.message);
                this.handleNotificationClick("tr", 1, response.data.message);
                this.setState({
                    is_success:true
                })
                this.get_filtered_adani_gas_station_txn_report(this.state.object_type,this.state.object_code,'');

            }).catch(err => {
                this.handleNotificationClick("tr", 3, "Error");

                this.setState({
                    is_success:true
                })

            });

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-bell" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Adani Gas station daily report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        <button type="button" className="primary apply-filter" role="button"  disabled={!this.state.is_success} onClick={this.refresh_txn.bind(this)}>Refresh</button>
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Transaction Type</label>
                                                <ReactMultiSelectCheckboxes name="txn_type"
                                                    isMulti
                                                    value={this.state.txnTypeValue}
                                                    styles={reactSelectStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.change_txn.bind(this)}
                                                    options={this.state.txnTypeLists}
                                                    placeholderButtonLabel="Select [Txn Type]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
{/*                                             <div className="col-md-2 filter-bottom5 padd-5"> */}
{/*                                                 <label>Ledger</label> */}
{/*                                                 <ReactMultiSelectCheckboxes name="txn_type" */}
{/*                                                     isMulti */}
{/*                                                     value={this.state.ledgerValue} */}
{/*                                                     styles={reactSelectStyles} className="report-listbox" */}
{/*                                                     isClearable={false} */}
{/*                                                     onChange={this.change_ledger.bind(this)} */}
{/*                                                     options={this.state.ledgerLists} */}
{/*                                                     placeholderButtonLabel="Select [Ledger]" */}
{/*                                                 /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
                                            {this.state.object_type ==='Innoviti' && this.state.object_code ==='Innoviti'?
                                            <React.Fragment>
                                             <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Email: </label>
                                                <AdaniUserFilter ref="adaniUserFilter" onSelectEmail = {this.handleEmail}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Gas Station Name: </label>
                                                <AdaniGasStationFilter ref="adaniGasStationFilter" onSelectGasStation = {this.handleGasStation}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Location: </label>
                                                <AdaniGasStationLocationFilter ref="adaniGasStationLocationFilter" onSelectGasStationLocation = {this.handleGasStationLocation}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            </React.Fragment>:null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }

                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_adani_gas_station_txn_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.adani_gas_station_txn_report_download.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <NotificationSystem ref="notificationSystem" style={style}/>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="AdaniGasDailyReportTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Customer Id </th>
                                                    <th>Customer Name</th>
                                                    <th>Customer contact</th>
                                                    <th>Vehicle Id</th>
                                                    <th>Vehicle Number</th>
                                                    <th>Driver ID</th>
                                                    <th>Driver Name</th>
                                                    <th>Driver contact number</th>
                                                    <th>Driver license number</th>
                                                    <th>Wallet ID</th>
                                                    <th>Assigned Wallet Balance</th>
                                                    <th>Gas Station ID</th>
                                                    <th>Gas Station Name</th>
{/*                                                     <th>Customer Location</th> */}
                                                    <th>Transaction ID</th>
                                                    <th>Transaction type</th>
                                                    <th>Flag</th>
                                                    <th>Transaction amount</th>
                                                    <th>UTID</th>
                                                    <th>Serial Number</th>
                                                    <th>Gas Station Location</th>
                                                    <th>Date</th>
                                                    <th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(AdaniGasStationDailyReport);